import { Car } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import type { RowAction } from '@/components/ui/row-actions-menu';

/**
 * «Nuovo viaggio» as a «···» menu item, for the phone; the wide screen has it behind «Nuova spesa ▾»
 * (#952 M7). «Veicoli», «Percorsi usuali» and «Rimborso chilometrico» are the rail's entries, so the
 * list no longer repeats them (decision 249).
 */
export function useMileageActions(canCreate: boolean): readonly RowAction[] {
  const { t } = useTranslation('expenses');
  const navigate = useNavigate();
  return canCreate
    ? [
        {
          id: 'trip',
          label: t('mileage.links.newTrip'),
          icon: Car,
          onSelect: () => void navigate('/expenses/trips/new'),
        },
      ]
    : [];
}
